import React from 'react';
import { ToastContainer } from 'react-toastify';

const Toaster = () => {
    return (
        <>
            <ToastContainer
                toastClassName="app-toast"
                bodyClassName="app-toast__body"
                position="top-center"
                autoClose={4500}
                hideProgressBar={false}
                closeOnClick={true}
                closeButton={true}
                rtl={false}
                draggable
                pauseOnHover
                newestOnTop
                pauseOnFocusLoss
            />
        </>
    )
}

export default Toaster
